var UserProfile = (function () {
    const baseuser = {
        id: 0,
        email: "",
        username: "",
        password: "",
        token: "",
        matricola: "",
        timeout: "",
        level: 1,
        isAuth: false
    };
    let user = baseuser;
    var saveLogin = function (newUser) {
        newUser.isAuth = true;
        localStorage.setItem('user-email', newUser.email);
        localStorage.setItem('user-matricola', newUser.matricola);
        localStorage.setItem('user-username', newUser.username);
        localStorage.setItem('user-token', newUser.token);
        localStorage.setItem('user-level', newUser.level);
        localStorage.setItem('user-isauth', true);
        user = newUser;
    };
    var getLogin = function () {
        return user;
    };
    var saveLogout = function () {
        localStorage.setItem('user-isauth', false);
        localStorage.setItem('user-token', '');
        user.isAuth = false;
        user.token = '';
    };
    var IsAuth = function () {
        return user.isAuth;
    };
    var init = function () {
        localStorage.getItem('user-email') != null ? user.email = localStorage.getItem('user-email') : user.email = '';
        localStorage.getItem('user-matricola') != null ? user.matricola = localStorage.getItem('user-matricola') : user.matricola = '';
        localStorage.getItem('user-username') != null ? user.username = localStorage.getItem('user-username') : user.username = '';
        localStorage.getItem('user-token') != null ? user.token = localStorage.getItem('user-token') : user.token = '';
        localStorage.getItem('user-level') != null ? user.level = Number(localStorage.getItem('user-level')) : user.level = 1;
        localStorage.getItem('user-isauth') != null && localStorage.getItem('user-isauth') == "true" ? user.isAuth = true : user.isAuth = false;
        refreshSession();
    };
    var refreshSession = function () {
        if (user.token != null && user.token != '') {
            const axios = require('axios');
            let data = JSON.stringify({
                Token: user.token,
            })
            axios.post('api/User/Refresh', data, { headers: { 'Content-Type': 'application/json' } })
                .then(resp => {
                    if (resp.data === null || resp.data === "") {
                        console.log('logout');
                        saveLogout();
                        document.location.href = '/login';
                        return false;
                    }
                })
                .catch(error => {
                    console.log('error');
                    saveLogout();
                    document.location.href = '/login';
                    return false;
                });
            return true;
        } else {
            return false;
        }
    };
    return {
        saveLogin: saveLogin,
        getLogin: getLogin,
        IsAuth: IsAuth,
        saveLogout: saveLogout,
        init: init,
        refreshSession: refreshSession
    }
})();

export default UserProfile;